import React from 'react';
import { Grid, Modal } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  Typography,
  patientAccessTheme,
} from '@HomaHealth/ui-component-library';
import { Button } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
// import NewEditDuration from '../NewEditDuration';
import componentConstants from '../../../core-utils/messages/componentConstants';
// import EditDurationModal from '../EditDurationModal';
// import { useStores } from '../../../stores';
import DateFilter from '../DateFilter';

export interface DownloadReportsPlanPeriodModalProps {
  open: boolean;
  // isYearSelection: boolean;
  handleClose: () => any;
  // startDateUseState: [string, React.Dispatch<React.SetStateAction<string>>];
  // endDateUseState: [string, React.Dispatch<React.SetStateAction<string>>];
  handleDownload: () => any;
  title?: string;
}

const DownloadReportsPlanPeriodModal: React.FC<DownloadReportsPlanPeriodModalProps> = ({
  open,
  handleClose,
  // startDateUseState,
  // endDateUseState,
  // isYearSelection,
  handleDownload,
  title,
}) => {
  const useStyles = makeStyles()({
    root: {
      width: '804px',
      backgroundColor: patientAccessTheme.palette.status.white,
      borderRadius: '8px',
      padding: '24px 32px',
      position: 'absolute',
      left: 'calc((100vw - 804px)/2)',
      top: 'calc((100vh - 358px)/2)',
      flexDirection: 'column',
    },
    button: {
      padding: '9px 16px',
      width: '102px',
      height: '36px',
      border: '1px solid ' + patientAccessTheme.palette.primary[500],
      borderRadius: '4px',
      textTransform: 'none',
      fontSize: '12px',
      lineHeight: '12px',
      fontWeight: 500,
    },
  });

   
  // const [startDate, setStartDate] = startDateUseState;
   
  // const [endDate, setEndDate] = endDateUseState;

  // const employerGroupStore = useStores().employerGroupStore;

  const { classes } = useStyles();
  const messages = componentConstants.PAGES.REPORTS;

  // const handleDateChange = () => {
  //   setStartDate(employerGroupStore?.selectedDuration?.startDate);
  //   setEndDate(employerGroupStore?.selectedDuration?.endDate);
  // };

  return (
    <Modal style={{ zIndex: 500 }} open={open} onClose={handleClose}>
      <Grid container className={classes.root}>
        <Grid>
          <Typography
            fontSize="18px"
            lineHeight="26px"
            fontType="medium"
            textColor={patientAccessTheme.palette.text.highemphasis}
            margin="0px 0px 4px 0px"
          >
            {title}
          </Typography>
        </Grid>
        <Grid>
          <Typography
            fontSize="14px"
            lineHeight="25px"
            textColor={patientAccessTheme.palette.text.highemphasis}
          >
            {messages.MODAL.SUBTITLE}
          </Typography>
        </Grid>
        <Grid
          style={{
            margin: '24px 0px',
            height: '35px',
            width: '740px',
          }}
        >
          {/* <NewEditDuration
            startDateUseState={startDateUseState}
            endDateUseState={endDateUseState}
            getAllApis={() => {}}
            showOnlyMainComponent={true}
            isYearGrid={isYearSelection}
          /> */}
          {/* <EditDurationModal
            isYearGrid={isYearSelection}
            isSummaryScreen={true}
            handleDateChange={handleDateChange}
            showOnlyMainComponent={true}
          /> */}
          <DateFilter />
        </Grid>
        <Grid
          container
          sx={{
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <Grid style={{ marginRight: '12px' }}>
            <Button
              label={messages.MODAL.CANCEL}
              variant="outlined"
              className={classes.button}
              onClick={handleClose}
            />
          </Grid>
          <Grid>
            <Button
              label={messages.MODAL.DOWNLOAD}
              variant="contained"
              className={classes.button}
              onClick={handleDownload}
            />
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default DownloadReportsPlanPeriodModal;
